import axios from 'axios'

export default {
  methods: {
    showErrorMessage (text) {
      this.$store.commit('app/setSnackbar', {
        value: true,
        text,
        color: 'red',
      })
    },
    showInfoMessage (text) {
      this.$store.commit('app/setSnackbar', {
        value: true,
        text,
        color: 'info',
      })
    },
    showWarningMessage (text) {
      this.$store.commit('app/setSnackbar', {
        value: true,
        text,
        color: 'warning',
      })
    },
    showSuccessMessage (text) {
      this.$store.commit('app/setSnackbar', {
        value: true,
        text,
        color: 'green',
      })
    },
    showErrorFromResponse (err) {
      if (axios.isCancel(err)) return

      let message
      if (err.response && err.response.data && (err.response.data.fullErrorMessage || err.response.data.message)) {
        message = err.response.data.fullErrorMessage || err.response.data.message
      } else {
        message = err.message
      }

      console.error(message)

      this.showErrorMessage(message)
      return message
    },

    getErrorMessageFromResponse (err) {
      if (axios.isCancel(err)) return

      let message
      if (err.response && err.response.data && (err.response.data.fullErrorMessage || err.response.data.message)) {
        message = err.response.data.fullErrorMessage || err.response.data.message
      } else {
        message = err.message
      }
      console.error(message)

      return message
    },
  },
}
